import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@luggagehero/shared/ui-pipes';
import { RatingModule } from 'ngx-bootstrap/rating';

@Component({
  selector: 'lh-shared-ui-ratings-summary',
  imports: [CommonModule, FormsModule, RatingModule, ReactiveFormsModule, TranslatePipe],
  templateUrl: './shared-ui-ratings-summary.component.html',
  styleUrl: './shared-ui-ratings-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedUiRatingsSummaryComponent {
  @Input() public averageRating: number | undefined;
  @Input() public numberOfRatings: number | undefined;
  @Input() public noRatingsText = 'NEW';
  @Input() public compact = true;

  public get hasNoRating(): boolean {
    return !this.numberOfRatings || this.averageRating == null;
  }

  public get ratingDisplayMax(): number {
    return this.compact ? 1 : 5;
  }

  public get ratingDisplayValue(): number {
    if (this.ratingDisplayMax === 1) {
      return 1;
    }
    return this.averageRating ?? 0;
  }
}
